import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class CommonServices {
    constructor(private toastr: ToastrService, private router: Router) { }

    toast(message: string) {
        this.toastr.info(message, 'Request Usage: ', { enableHtml: true });
    }


    toastsuccess(message:string){
        this.toastr.success(message);
    }

    toastE(message: string) {
        this.toastr.error(message, 'Limit Exceeded', { enableHtml: true });
    }
    toastCustomError(message: string) {
        this.toastr.error(message);
    }
    toastPersistent(message: string, title: string) {
        // Create the HTML message with an anchor tag
        const htmlMessage = `
            ${message} <a href="https://www.google.com" id="toast-link" style="color: blue; text-decoration: underline;">Click here</a>
        `;
    
        // Display the toast with the HTML message
        this.toastr.error(htmlMessage, title, {
            timeOut: 0,
            enableHtml: true,
            onActivateTick: true // Ensure the toast is fully rendered before attaching the event
        }).onShown.subscribe(() => {
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        const link = document.getElementsByTagName('a');
                        console.log(link)
                    }
                }
            });
    
            // Start observing the body or the specific container where the toast is rendered
            observer.observe(document.body, { childList: true, subtree: true });
        });
    }
    
    
    
    getErrorMessage(error: any) {
        var errorMessage = '';
        if (Array.isArray(error.error.requestIssue)) {
            errorMessage = error.error.requestIssue.join(', ');
        } else if (typeof error.error.requestIssue === 'string') {
            errorMessage = error.error.requestIssue;
        } else {
            errorMessage = 'An unknown error occurred';
        }
        return errorMessage;
    }

    toastUsageEllmo(res: any) {
        const uploadStatus = res.uploadStatus;

        if (!uploadStatus || !Array.isArray(uploadStatus)) {
            this.toastE('Invalid response format');
            return;
        }

        let totalWords = 0;

        uploadStatus.forEach((fileStatus: any) => {
            if (fileStatus.requestAllowed) {
                const requestUsage = fileStatus.requestUsage;
                if (requestUsage) {
                    Object.values(requestUsage).forEach((usage: any) => {
                        const wordsMatch = usage.match(/(\d+) words/);
                        if (wordsMatch) {
                            totalWords += parseInt(wordsMatch[1], 10);
                        }
                    });
                }
            } else if (fileStatus.requestAllowed === false) {
                this.toastE(fileStatus.requestIssue);
                return;
            }
        });

        const usageMessage = `${totalWords} words`;
        console.log('toasting ' + usageMessage);
        this.toast(usageMessage);
    }


    toastUsage(res: any) {
        const requestAllowed = res.requestAllowed;
        if (!requestAllowed && requestAllowed == false) {
            this.toastE(res.requestIssue);
            return;
        }

        const usageData = res.requestUsage;
        if (requestAllowed && usageData) {
            const usageMessage = Object.entries(usageData)
                .map(([key, value]) => `${key}: ${value}`)
                .join(' | ');
            console.log('toasting ' + usageMessage)
            this.toast(usageMessage);
        }
    }


    navigateTo(url: string, newTab: boolean): void {
        if (url.indexOf("refer") > 0 || url.indexOf("subscribe") > 0) {
            newTab = false;
        }

        if (newTab) {
            window.open(
                url,
                '_blank'
            );
        } else {
            this.router.navigate([url]);
        }
    }
}
